import React, { useState, useEffect } from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import "./Pagination.scss";
import "./Responsive.scss";

const Pagination = ({ currentPage, maxPage, setPage, next, prev }) => {
  const [groupCount, setGroupCount] = useState(0);
  const dec = () => {
    setGroupCount(groupCount - 1);
  }
  const inc = () => {
    setGroupCount(groupCount + 1);

  }

  useEffect(() => { setGroupCount(0); }, [currentPage]);

  const paginationRender = () => {
    let paginate = [];
    if (maxPage !== 1) {
      for (let i = 1; i <= maxPage; i++) {
        if (i === 1) {
          paginate.push(<li key={1} onClick={i !== currentPage ? (e) => setPage(e) : null} className={i === currentPage ? "pageNumbers active" : "pageNumbers"}>1</li>);
          if (currentPage + (2 * groupCount) > 3) {
            paginate.push(<li onClick={dec} key={998} className="pageDots">...</li>);
          }
        }
        else if ((i > (currentPage + (2 * groupCount) - 2)) && (i < (currentPage + (2 * groupCount) + 2))) {
          paginate.push(<li key={i} onClick={(e) => setPage(e)} className={i === currentPage ? "pageNumbers active" : "pageNumbers"}>{i}</li>);
        }
        else if (i === maxPage) {
          if (currentPage + (2 * groupCount) <= maxPage - 3) {
            paginate.push(<li onClick={inc} key={999} className="pageDots">...</li>);
          }
          paginate.push(<li key={maxPage} onClick={currentPage !== maxPage ? (e) => setPage(e) : null} className={i === currentPage ? "pageNumbers active" : "pageNumbers"}>{maxPage}</li>);
        }
      }
    }
    return paginate;
  }

  return (
    <div className="pagination">
      <ul className="page">
        <li className={currentPage <= 1 ? "pageBtn disable" : "pageBtn"}>
          <FaAngleLeft onClick={prev} />
        </li>
        {paginationRender()}
        <li className={maxPage === currentPage ? "pageBtn disable" : "pageBtn"}>
          <FaAngleRight onClick={next} />
        </li>
      </ul>
    </div>
  );
};

export default React.memo(Pagination);
